import { categories } from '@/constants/categories';

interface CategoryBadgeProps {
  categoryId: number;
  categoryName: string;
}

export function CategoryBadge({ categoryId, categoryName }: CategoryBadgeProps) {
  const category = categories.find((c) => c.id === categoryId);

  if (!category?.icon) {
    return (
      <span className="inline-flex items-center gap-2 rounded-md bg-gray-100 px-3 py-1.5 text-sm font-medium text-gray-700">
        {categoryName}
      </span>
    );
  }

  const Icon = category.icon;

  return (
    <span
      className={`inline-flex items-center gap-2 rounded-md px-2 py-1.5 ${category.iconBg} ${category.iconText} text-sm font-medium`}
    >
      <Icon size={16} />
      <span>{categoryName}</span>
    </span>
  );
}
